import React, { Component } from 'react';
import stl from 'string-to-color';
import { Checkbox, Avatar, Tag, Button, Space, Collapse } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useGetPlanningResource, useGetCSVFieldsList, useUpdatePlanningResource } from '../../hooks/usePlanning';
import { useState } from 'react';
import { useEffect } from 'react';
import style from './index.module.css';
import AddResource from './AddResource';

export default function ManageResource({ companyCode, type }) {
    const [resource, setPlaceHolderModels] = useState([]);
    const [isChanged, setIsChanged] = useState(false);
    const [showAddResource, setShowAddResource] = useState(false);

    const {
        data,
        isFetching: isFetchingplaceHolderModels,
        isFetched: isFetchedplaceHolderModels,
        refetch: refetchplaceHolderModels,
    } = useGetPlanningResource(companyCode, type);
    const { data: csvFieldsList, isFetching: isFetchingcsvFieldsList, isFetched: isFetchedcsvFieldsList } = useGetCSVFieldsList(companyCode);

    const UpdatePlanningResourceMutation = useUpdatePlanningResource();

    useEffect(() => {
        setPlaceHolderModels(data);
        setIsChanged(false);
    }, [data, isFetchingplaceHolderModels]);

    const HandleFilterValueChange = (checked, modelId, key, path, value, filterIndex, modelIndex, csvFieldIndex) => {
        // console.log({ checked, modelId, key, path, value, filterIndex, modelIndex, csvFieldIndex, placeHolderModels });
        const modelsData = { ...resource };
        const filter = modelsData?.data[modelIndex]?.filters?.[filterIndex];
        if (!!filter?.filter) {
            const i = filter?.filter?.findIndex(d => d.key == key && d.path == path);
            if (i < 0) {
                // create new filter
                if (!!checked) {
                    modelsData.data[modelIndex].filters[filterIndex].filter.push({
                        key: key,
                        path: path,
                        value: [value],
                    });
                }
            } else {
                let valueList = modelsData?.data[modelIndex]?.filters?.[filterIndex]?.filter?.[i]?.value;
                if (checked) {
                    if (!valueList) {
                        valueList = [value];
                    } else if (valueList?.includes(value) == false) {
                        valueList.push(value);
                    }
                } else {
                    valueList = valueList.filter(d => d != value);
                }
                if (valueList?.length == 0) {
                    let tempObj = modelsData.data[modelIndex].filters[filterIndex].filter;
                    const removed = tempObj.splice(i, 1);
                    console.log({ removed, tempObj });
                    modelsData.data[modelIndex].filters[filterIndex].filter = tempObj;
                } else {
                    modelsData.data[modelIndex].filters[filterIndex].filter[i].value = valueList;
                }
            }
            console.log({ i });
        } else {
            modelsData.data[modelIndex].filters[filterIndex] = {
                filter: [
                    {
                        key: key,
                        path: path,
                        value: [value],
                    },
                ],
                filterWeightage: 1,
                test: 'test',
            };
            console.log('empty case', filter.filter);
        }
        setPlaceHolderModels(modelsData);
        setIsChanged(true);

        console.log({ modelsData });
    };

    const HandleAddFilterToModel = (modelId, modelIndex) => {
        const modelsData = { ...resource };
        modelsData?.data[modelIndex]?.filters.push({});
        setPlaceHolderModels(modelsData);
        setIsChanged(true);
    };

    const HandleRemoveFilterFromModel = (modelIndex, filterIndex) => {
        const modelsData = { ...resource };
        const tempFilters = modelsData?.data[modelIndex]?.filters;
        tempFilters?.splice(filterIndex, 1);
        setPlaceHolderModels(modelsData);
        setIsChanged(true);
    };

    const HandleSaveModelsData = () => {
        UpdatePlanningResourceMutation.mutateAsync([companyCode, type, resource?.data])
            .then(() => {})
            .catch(error => {})
            .finally(() => {
                refetchplaceHolderModels();
            });
    };

    const HandleAddResource = formData => {
        const { name, capacity } = formData;
        const tempData = { ...resource };
        tempData.data.push({
            name: name,
            filters: [
                {
                    filter: [{}],
                    filterWeightage: 1,
                },
            ],
            capacity: capacity,
        });
        setPlaceHolderModels(tempData);
        setShowAddResource(false);
        setIsChanged(true);
    };

    const HandleRemoveModel = modelIndex => {
        const tempData = { ...resource };
        tempData.data.splice(modelIndex, 1);
        setPlaceHolderModels(tempData);
        setShowAddResource(false);
        setIsChanged(true);
    };

    const OpenAddModelForm = () => {
        setShowAddResource(true);
    };

    const CSVFieldCard = ({ modelId, csvField, checked = [], filterIndex, modelIndex, csvFieldIndex }) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        // border: '1px solid blue',
                        padding: '10px',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'flex-start',
                    }}
                    key={`CSVFieldCard:${filterIndex}-${modelIndex}-${csvFieldIndex}-${modelId}`}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start',
                            minHeight: '250px',
                            minWidth: '150px',
                            border: '1px solid black',
                            // overflow: 'auto',
                            borderRadius: '13px 13px 0 0',
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: 'gray',
                                width: '100%',
                                borderRadius: '13px 13px 0 0',
                                padding: '10px',
                                alignItems: 'center',
                            }}
                        >
                            <h3
                                style={{
                                    color: 'white',
                                }}
                            >
                                {csvField?.key}
                            </h3>
                        </div>

                        {csvField?.value?.map((value, valueIndex) => {
                            return (
                                <div
                                    style={{
                                        marginLeft: '5px',
                                    }}
                                >
                                    <Checkbox
                                        checked={checked?.includes(value)}
                                        key={`${modelId}-${csvField?.key}-${csvField?.path}-${valueIndex}`}
                                        onClick={e =>
                                            HandleFilterValueChange(
                                                e?.target?.checked,
                                                modelId,
                                                csvField?.key,
                                                csvField?.path,
                                                value,
                                                filterIndex,
                                                modelIndex,
                                                csvFieldIndex
                                            )
                                        }
                                    >
                                        {value}
                                    </Checkbox>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </>
        );
    };

    const CSVFieldsCard = ({ csvFields, filterObj, modelId, filterIndex, modelIndex }) => {
        return (
            <>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        border: '1px solid #777',
                        boxShadow: '1px 2px 4px #777',
                        padding: '10px',
                        margin: '10px',
                        position: 'relative',
                    }}
                >
                    {csvFields?.data?.map((csvField, csvFieldIndex) => {
                        const matched = filterObj?.filter?.find(d => d.path == csvField.path && d.key == csvField.key);
                        return (
                            <CSVFieldCard
                                modelId={modelId}
                                csvField={csvField}
                                checked={matched?.value}
                                key={`${modelId}-${csvField?.key}-${csvField?.path}-${csvFieldIndex}`}
                                filterIndex={filterIndex}
                                modelIndex={modelIndex}
                                csvFieldIndex={csvFieldIndex}
                            />
                        );
                    })}
                    <div
                        style={{
                            position: 'absolute',
                            top: '-10px',
                            right: '-20px',
                        }}
                    >
                        <Tag.CheckableTag
                            color="red"
                            style={{
                                color: 'red',
                                backgroundColor: 'white',
                                border: '1px solid red',
                            }}
                            className={style.tag_button}
                            onClick={() => HandleRemoveFilterFromModel(modelIndex, filterIndex)}
                        >
                            <DeleteOutlined />
                        </Tag.CheckableTag>
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <div
                style={{
                    width: '100%',
                    height: '100%',
                    // backgroundColor: 'red',
                    margin: '10px',
                    padding: '10px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '10px 0',
                    }}
                >
                    <h2>{`Manage ${type}`}</h2>
                    <Button onClick={() => OpenAddModelForm(true)}>{`Add ${type}`}</Button>
                </div>
                <hr />
                <div
                    style={{
                        height: 'calc(100vh - 200px)',
                        overflow: 'auto',
                        backgroundColor: '#eee',
                    }}
                >
                    {resource?.data?.map((placeHolderModel, modelIndex) => {
                        return (
                            <>
                                <div
                                    style={{
                                        border: `1px solid #777`,
                                        borderRadius: '13px 13px 0 0',
                                        margin: '10px',
                                    }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            padding: '10px',
                                            backgroundColor: 'gray',
                                            borderRadius: '13px 13px 0 0',
                                        }}
                                    >
                                        <h1
                                            style={{
                                                color: 'white',
                                                fontSize: '26px',
                                            }}
                                        >
                                            {placeHolderModel?.name}
                                        </h1>
                                        <Space>
                                            <Button onClick={() => HandleAddFilterToModel(placeHolderModel?.name, modelIndex)}>Add Capability</Button>
                                            <Button onClick={() => HandleRemoveModel(modelIndex)}>Delete</Button>
                                        </Space>
                                    </div>
                                    <div
                                        key={`placeHolderModel:${placeHolderModel?.name}-${modelIndex}`}
                                        style={{
                                            margin: '10px',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'flex-start',
                                            alignItems: 'flex-start',
                                            padding: '10px',
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        {placeHolderModel?.filters?.map((filter, filterIndex) => {
                                            return (
                                                <CSVFieldsCard
                                                    modelId={placeHolderModel?.name}
                                                    csvFields={csvFieldsList}
                                                    filterObj={filter}
                                                    key={`CSVFieldsCard:${placeHolderModel?.name}-${filterIndex}-${modelIndex}`}
                                                    modelIndex={modelIndex}
                                                    filterIndex={filterIndex}
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                            </>
                        );
                    })}
                </div>
                <hr />
                <Space
                    style={{
                        display: 'flex',
                        width: '100%',
                        padding: '5px 10px',
                        margin: '10px 0',
                        justifyContent: 'flex-end',
                        // boxShadow: '0px -1px 3px #777',
                        // backgroundColor: '#77777777',
                        alignItems: 'center',
                    }}
                >
                    <Button type="primary" onClick={() => HandleSaveModelsData()} disabled={!isChanged}>
                        Save
                    </Button>
                    <Button type="default" onClick={() => refetchplaceHolderModels()} disabled={!isChanged}>
                        Cancel
                    </Button>
                </Space>
            </div>
            {!!showAddResource && (
                <AddResource
                    type={type}
                    onCancel={() => setShowAddResource(false)}
                    onOk={HandleAddResource}
                    open={showAddResource}
                    key={'Add Model'}
                />
            )}
        </>
    );
}
